import { useContext } from 'react';
import { BannerFpContext } from '../../../../Contexts/BannerFpContext';
import { Grid, Paper } from '@mui/material';

import BannerFpEngineModelCard from './BannerFpEngineModelCard';
import { CONFIG_STRUCTURE_KEYS } from '../../constants';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';
const { FLOOR_PRICING_CONFIG, FLOOR_ENGINE_TYPE_SPLIT } = CONFIG_STRUCTURE_KEYS;

const FloorEngineTypeSplit = () => {
	const { bannerFpConfig, updateBannerFpConfig } = useContext(BannerFpContext);

	const bannerFpModels =
		(bannerFpConfig &&
			bannerFpConfig[FLOOR_PRICING_CONFIG] &&
			Array.isArray(bannerFpConfig[FLOOR_PRICING_CONFIG][FLOOR_ENGINE_TYPE_SPLIT]) &&
			bannerFpConfig[FLOOR_PRICING_CONFIG][FLOOR_ENGINE_TYPE_SPLIT]) ||
		[];

	const addBannerFpModel = () => {
		const initialBannerFpModel = { engineType: '', trafficSplit: 0 };
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		if (!clonedBannerFpConfig[FLOOR_PRICING_CONFIG]) {
			clonedBannerFpConfig[FLOOR_PRICING_CONFIG] = {};
		}
		if (!clonedBannerFpConfig[FLOOR_PRICING_CONFIG][FLOOR_ENGINE_TYPE_SPLIT]) {
			clonedBannerFpConfig[FLOOR_PRICING_CONFIG][FLOOR_ENGINE_TYPE_SPLIT] = [];
		}
		clonedBannerFpConfig[FLOOR_PRICING_CONFIG][FLOOR_ENGINE_TYPE_SPLIT].push(initialBannerFpModel);
		updateBannerFpConfig(clonedBannerFpConfig);
	};

	const deleteBannerFpModel = (index) => {
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		const floorEngineTypeSplit =
			clonedBannerFpConfig[FLOOR_PRICING_CONFIG][FLOOR_ENGINE_TYPE_SPLIT];
		const newFloorEngineTypeSplitArr = floorEngineTypeSplit.filter((data, idx) => idx !== index);
		clonedBannerFpConfig[FLOOR_PRICING_CONFIG][FLOOR_ENGINE_TYPE_SPLIT] =
			newFloorEngineTypeSplitArr;
		updateBannerFpConfig(clonedBannerFpConfig);
	};

	const commonStyleClasses = useCommonStyles();
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Floor Engine Type Split"
				headingPath={['Dashboard', 'Banner Fp', 'Floor Pricing', 'Floor Engine Type Split']}
			/>
			<Grid
				container
				spacing={2}
				style={{ marginTop: '1.5rem', marginRight: '4rem', width: '100%' }}
			>
				{bannerFpConfig && (
					<>
						{bannerFpModels.map((bannerFpModel, index) => {
							return (
								<BannerFpEngineModelCard
									bannerFpModel={bannerFpModel}
									deleteBannerFpModel={deleteBannerFpModel}
									key={index}
									index={index}
								/>
							);
						})}
						<Grid item xs={12} style={{ textAlign: 'center' }}>
							<AddCircleOutlineOutlinedIcon
								color="primary"
								fontSize="medium"
								className={commonStyleClasses.icon}
								onClick={addBannerFpModel}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</Paper>
	);
};

export default FloorEngineTypeSplit;
